"use strict";

class ProductsDataLayer {
    constructor() {
        this.dataLayer = window.dataLayer || [];

        this.registerEvents();
    }

    registerEvents() {
        document.addEventListener("cart-updated", (e) => {
            this.updateCartProducts(e.detail.response, 1);
        });

        document.addEventListener("update-cart", (e) => {
            const response = e.detail.response;
            const quantity = e.detail.quantity || 1;
            this.setProductGtmData(response, quantity, "add_to_cart");
        });
    }

    resetEcommerce() {
        this.dataLayer.push({ ecommerce: null });
    }

    parseGtmData(gtmData) {
        try {
            return gtmData ? JSON.parse(gtmData) : null;
        } catch (error) {
            console.error("Error parsing GTM data:", error);
            return null;
        }
    }

    formatPrice(price) {
        return +(price / 100).toFixed(2);
    }

    setProductGtmData(response, quantity, event) {
        if (!response) return;

        let price = this.formatPrice(response.final_price)

        let data = {
            event: event,
            ecommerce: {
                currency: ShopifyAnalytics.meta.currency,
                value: price,
                items: {
                    id: response.id,
                    price: price,
                    quantity: quantity,
                    display_price: price,
                    display_price_currency: ShopifyAnalytics.meta.currency,
                    item_name: response.sku
                        .split('.')
                        .slice(0, 2)
                        .join('.'),
                    item_id: response.sku
                        .split('.')
                        .slice(0, 2)
                        .join('.'),
                    item_category: response.product_type,
                    item_variant: response.sku,
                    item_list_name: 'Category Overview',
                    item_list_id: 'category',
                },
            },
        };

        this.cartItems = null;
        this.resetEcommerce();
        this.dataLayer.push(data);
    }

    updateCartProducts(response) {
        if (!response) return;

        let item = response.items_added?.[0] ?? response.items_removed?.[0];

        if (!item) return;

        const updatedItemId = item.variant_id;
        const updatedProduct =
            response?.items.find((item) => item.variant_id === updatedItemId) ??
            this.cartItems?.find((item) => item.variant_id === updatedItemId);

        if (!updatedProduct) return;

        if (updatedProduct && response.items_added.length) {
            const items_added = response?.items_added[0]?.quantity;
            updatedProduct.quantity = items_added;
            updatedProduct.price = this.formatPrice(updatedProduct.price);

            this.setProductGtmData(
                updatedProduct,
                items_added,
                "add_to_cart",
            );
        } else if (response.items_removed.length) {
            const items_removed = response?.items_removed[0]?.quantity;
            updatedProduct.quantity = items_removed;
            updatedProduct.price = this.formatPrice(updatedProduct.price);

            this.setProductGtmData(
                updatedProduct,
                items_removed,
                "remove_from_cart",
            );
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new ProductsDataLayer());
